export default __webpack_public_path__ + "static/media/4-sgi-home-v2.b0909a0c.png";